"use client";

import * as React from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useGetList } from "react-admin";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { Portal } from "@radix-ui/react-popover";

interface Props {
  formProp: any;
  setFormProp: Function;
  resource: string;
  prop: string;
}

const DataAutofillSelect: React.FC<Props> = ({
  formProp,
  setFormProp,
  resource,
  prop,
}) => {
  const { data } = useGetList(resource);
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [obj, setObj] = React.useState(formProp);

  React.useEffect(() => {
    setFormProp((prev: any) => {
      return {
        ...prev,
        ...obj,
      };
    });
  }, [value]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      < PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[200px] justify-between"
        >
          {value
            ? (data && data.find((item) => item[prop] === value)[prop]) || ""
            : "Select..."}
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent className="w-[200px] p-0 z-[99] pointer-events-auto">
          <Command>
            <CommandInput placeholder="Search..." className="h-9" />
            <CommandList>
              <CommandEmpty>No result found.</CommandEmpty>
              <CommandGroup>
                {data &&
                  data.map((framework) => (
                    <CommandItem
                      key={framework.id}
                      value={framework[prop]}
                      className="mb-1 cursor-pointer"
                      onSelect={(currentValue) => {
                        let newObj: any = {}
                        Object.keys(formProp).map(key => newObj[key] = framework[key])
                        setValue(currentValue === value ? "" : currentValue);
                        setObj(newObj);
                        setOpen(false);
                      }}
                    >
                      {framework[prop]}
                      
                      <Check
                        className={cn(
                          "ml-auto",
                          value === framework[prop]
                            ? "opacity-100"
                            : "opacity-0",
                        )}
                      />
                    </CommandItem>
                  ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default DataAutofillSelect;
